<!-- <div class="fixed top-4 right-4 z-50 flex flex-col space-y-4">
  <div *ngFor="let n of notifications()" [ngClass]="getClass(n.type)" class="border px-4 py-3 rounded relative shadow-md transition-all duration-300 ease-in-out">
    <span>{{ n.message }}</span>
    <button class="absolute top-1 right-2 text-lg" (click)="close(n.id)" aria-label="Close notification">✖</button>
  </div>
</div> -->

@for (n of notifications(); track $index) {
  <div class="fixed z-[9999999999] rounded  min-w-64 p-4 top-6 right-6 flex border justify-between items-center gap-4" [ngClass]="getClass(n.type)">
    <i class="fa-regular fa-circle-question"></i>
    <p class="mb-0">{{ n.message }}</p>
    <button type="button"  (click)="close(n.id)" class="text-gray-700"><i class="fa-solid fa-xmark"></i></button>
      
  </div>
  
  }
